import { useEffect } from 'react'

export const useHomeFavicon = (faviconUrl: string | null | undefined) => {
  useEffect(() => {
    if (!faviconUrl) return
    const href = faviconUrl.trim()
    if (!href || typeof document === 'undefined') return

    let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (!favicon) {
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      document.head.appendChild(favicon)
    }
    favicon.href = href
  }, [faviconUrl])
}
